export default __webpack_public_path__ + "static/media/statistics.9fb25a6f.svg";